var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M17.5 22 23 12 17.5 2h-11L1 12l5.5 10zM12 15.158c1.5 0 3-1.298 3-3.158s-1.5-3.158-3-3.158S9 10.14 9 12s1.5 3.158 3 3.158",
    clipRule: "evenodd"
  })));
};
export default SvgSetting;